export default "__VITE_ASSET__CsOlWQsV__"